import React, { FC } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "../../../components/Button";
import FontIcon from "../../../components/FontIcon";
import { AdapterLink } from "../../../components/Adopter";
import { Routes } from "../../../constants/routes";
import { SERVICE_TYPE_NAME_MAP } from "../constants";

const useStyles = makeStyles(() => ({
  categoryCardContainer: {
    height: "100%",
    borderRadius: 16,
    boxShadow: "0 0 4px 0 #c2c9d6",
    padding: 30,
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "nowrap",
  },
  iconNameContainer: {
    display: "flex",
    alignItems: "center",
  },
  name: {
    fontWeight: 500,
    lineHeight: 1.33,
    color: "#231f20",
    fontSize: "1.25rem",
  },
  iconContainer: {
    borderRadius: 10,
    backgroundColor: "#eeeeed",
    padding: "0.625rem",
    marginRight: "1.875rem",
  },
  icon: {
    verticalAlign: "middle",
    borderStyle: "none",
  },
  button: {
    minWidth: 220,
  },
}));

interface ICategoryCardProps {
  id: number;
  name: string;
  icon: string;
}

export const CategoryCard: FC<ICategoryCardProps> = ({ id, name, icon }) => {
  const classes = useStyles();

  const onViewCategory = () => {
    // Logic to handle viewing the category
    // https://dev.worlded.us/services/lawyer-consultation
  };

  return (
    <div className={classes.categoryCardContainer}>
      <div className={classes.iconNameContainer}>
        <div className={classes.iconContainer}>
          <FontIcon name={icon} />
        </div>
        <p className={classes.name}>{name}</p>
      </div>
      <AdapterLink
        to={`/0/${Routes.SERVICE_LIST}/category/${SERVICE_TYPE_NAME_MAP[id]}`}
      >
        <Button
          variant={"contained"}
          color={"secondary"}
          className={classes.button}
          onClick={onViewCategory}
        >
          View Category
        </Button>
      </AdapterLink>
    </div>
  );
};
